var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiyalMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 11.2175,
    height: 12.48,
    viewBox: "0 0 11.2175 12.48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xEF\xB7\xBC",
    d: "M6.7334 9.7373V6.9946L5.16614 7.31386V8.91014C5.16614 9.03556 5.13712 9.14751 5.07907 9.24391L4.368 10.2742C4.21356 10.5354 3.98137 10.6951 3.67144 10.7531L0 11.5222C0.0580465 11.0962 0.17414 10.6806 0.348279 10.2742L4.03423 9.4906V7.56056L0.638512 8.28614C0.687229 7.87048 0.79814 7.44965 0.972279 7.02363L4.03423 6.38512V0.972279C4.34416 0.604306 4.72146 0.280904 5.16614 0V6.13842L6.7334 5.81916V1.65433C7.03296 1.27702 7.41026 0.952585 7.8653 0.682046V5.55795L11.2175 4.84688C11.1791 5.07907 11.1356 5.29674 11.0869 5.49991C11.0382 5.70307 10.9615 5.90623 10.8547 6.1094L7.8653 6.74791V8.31516L11.2175 7.6186C11.1791 7.84146 11.1356 8.05395 11.0869 8.25712C11.0382 8.45095 10.9615 8.64893 10.8547 8.85209L6.7334 9.7373ZM11.2175 10.3613C11.1791 10.5738 11.1356 10.7873 11.0869 10.9998C11.0382 11.2123 10.9615 11.4155 10.8547 11.6093L6.7334 12.48C6.76242 12.2571 6.80077 12.0447 6.84949 11.8415C6.90754 11.6477 6.98942 11.4445 7.09619 11.232L11.2175 10.3613Z",
    fill: "#0D44AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyalMd);
export default __webpack_public_path__ + "static/media/riyal-md.b49fccdafda44805858e0bfecd6d0ce3.svg";
export { ForwardRef as ReactComponent };